import { FC, ReactNode } from 'react'
import { twMerge } from '@lib/tailwind-merge'

interface Props {
  className?: string
  children: ReactNode
  description: string
  label: string
  leftSlot?: ReactNode
}

export const TwoColumn: FC<Props> = ({
  className,
  label,
  description,
  children,
  leftSlot,
}) => (
  <div
    className={twMerge(
      'flex flex-row py-6 border-b first-of-type:pt-0 gap-8 border-neutral-200 last-of-type:border-0',
      className,
    )}
  >
    <div className="flex flex-col basis-1/3 min-w-[256px]">
      <label className="text-lg font-medium text-neutral-900">{label}</label>
      <span className="text-xs text-neutral-600 font-normal">
        {description}
      </span>
      {leftSlot && <div className="mt-4">{leftSlot}</div>}
    </div>
    <div className="flex flex-row items-center basis-2/3">{children}</div>
  </div>
)
